<template>
  <div class="content">
    <div class="head">
      <h2>管理者用ページ</h2>
    </div>

    <div class="login">
      <div class="container">
        <div class="row">
          <div @click="modalOpen('ichiran')" class="columns button">
            クラス一覧
          </div>
          <div @click="getLog()" class="columns button">ログの取得</div>
          <!-- 後で実装
          <div @click="modalOpen('history')" class="columns button">
            ログの削除
          </div>
          <div @click="modalOpen('delClass')" class="columns button">
            資金決済法、特定商取引法等のテキスト
          </div>
          <div @click="modalOpen('delClass')" class="columns button">
            景品の当選割合の変更
          </div>
          -->
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="modal" v-if="modal">
        <div v-if="ichiran">
          <table>
            <thead>
              <tr>
                <th>クラス</th>
                <th>生徒数</th>
                <th>着目機能</th>
                <th>簡単</th>
                <th>電話料金</th>
                <th>確率調整</th>
                <th>更新日</th>
                <th>データ</th>
                <th>削除</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="classData in classes">
                <tr :key="classData.index + '_1'">
                  <td rowspan="2">{{ classData.classNum }}</td>
                  <td>{{ classData.stNum }}</td>
                  <td>{{ classData.effect }}</td>
                  <td>{{ classData.easy }}</td>
                  <td>{{ classData.denwaUse }}</td>
                  <td>{{ classData.rateReg }}</td>
                  <td>{{ classData.updated_at }}</td>
                  <td>
                    <div
                      @click="showClass(classData.classNum)"
                      class="tableButton"
                    >
                      見る
                    </div>
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      :value="classData.classNum"
                      v-model="classNum"
                    />
                  </td>
                </tr>
                <tr :key="classData.index + '_2'">
                  <td colspan="2">{{ classData.classMemo }}</td>
                  <td colspan="5">
                    <textarea
                      v-model="classData.adminMemo"
                      class="adminMemo"
                      v-if="editMemo"
                    ></textarea>
                  </td>
                  <td>
                    <button
                      v-bind:disabled="buttonDisabled"
                      @click="editMemo(classData.classNum, classData.adminMemo)"
                      class="tableButton"
                    >
                      変更
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <button type="button" @click="modalCancel('modal')">閉じる</button>
          <button type="button" @click="delClasses()">削除する</button>
          <p class="caution" v-if="caution">
            削除するにはクラスを選択してください
          </p>
        </div>
        <transition name="fade">
          <div class="modalInfo" v-if="modalInfo">
            {{ infoText }}
          </div>
        </transition>
      </div>
    </transition>

    <transition name="fade">
      <div class="modal" v-if="dataModal">
        <table>
          <thead>
            <tr>
              <th>名前</th>
              <th>保有コイン</th>
              <th>ガチャ回数</th>
              <th>チケットコード</th>
              <th>電話料金合算払い</th>
              <th>保護者同意</th>
              <th>同意キャンセル回数</th>
              <th>年齢確認</th>
              <th>年齢キャンセル回数</th>
              <th>最終更新日</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="rirekidata in rows">
              <tr :key="rirekidata.index + '_1'">
                <td rowspan="2">{{ rirekidata.stName }}</td>
                <td>{{ rirekidata.points }}</td>
                <td>{{ rirekidata.gachaTimes }}</td>
                <td>{{ rirekidata.cardTotal }}</td>
                <td>{{ rirekidata.denwaTotal }}</td>
                <td>{{ rirekidata.consent }}</td>
                <td>{{ rirekidata.consent_num }}</td>
                <td>{{ rirekidata.age }}</td>
                <td>{{ rirekidata.age_num }}</td>
                <td>{{ rirekidata.updated_at }}</td>
              </tr>
              <tr :key="rirekidata.index + '_2'">
                <td colspan="9">{{ rirekidata.prize }}</td>
              </tr>
            </template>
            <tr class="totalcolumn">
              <td>合計</td>
              <td>{{ totalCoin }}</td>
              <td>{{ totalGacha }}</td>
              <td>{{ totalCard }}</td>
              <td>{{ totalDenwa }}</td>
            </tr>
          </tbody>
        </table>
        <button type="button" @click="modalCancel('dataModal')">閉じる</button>
      </div>
    </transition>

    <!-- クラス削除確認 -->
    <transition name="fade">
      <div class="modalCaution" v-if="modalCaution">
        <p v-html="modalText"></p>
        <div>
          <button type="button" v-if="delClass" @click="del()">削除する</button>
          <button type="button" @click="modalCancel('caution')">Cancel</button>
        </div>
        <p class="caution" v-if="delInfo">
          クラス {{ delClass }} を削除しました。
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "classroom",
  data() {
    return {
      modal: false,
      modalInfo: false,
      infoText: "",
      dataModal: false,
      ichiran: false,
      classes: [],
      rows: [],
      modalCaution: false,
      modalText: "",
      classNum: [],
      delClass: [],
      caution: false,
      delInfo: false,
      buttonDisabled: false,
    };
  },
  beforeCreate() {
    if (!this.$store.state.loggedIn) {
      this.$router.push({ name: "class" });
    }
  },
  methods: {
    modalOpen: function (e) {
      this.modal = true;
      this.cuation = false;
      this.modalCaution = false;
      var self = this;
      if (e == "ichiran") {
        self.ichiran = true;
        axios.get(self.$store.state.APIbase + "api/classrooms").then((res) => {
          self.classes = res.data;
        });
      }
    },
    showClass: function (e) {
      this.dataModal = true;
      var self = this;
      axios
        .get(self.$store.state.APIbase + "api/rireki_ad/" + e)
        .then((res) => {
          self.rows = res.data;
          self.totalCoin = self.rows.reduce(function (sum, coin) {
            return sum + parseInt(coin.points, 10);
          }, 0);
          self.totalGacha = self.rows.reduce(function (sum, coin) {
            return sum + parseInt(coin.gachaTimes, 10);
          }, 0);
          self.totalCard = self.rows.reduce(function (sum, coin) {
            return sum + parseInt(coin.cardTotal, 10);
          }, 0);
          self.totalDenwa = self.rows.reduce(function (sum, coin) {
            return sum + parseInt(coin.denwaTotal, 10);
          }, 0);
        });
    },
    editMemo: function (classNum, adminMemo) {
      var self = this;
      self.buttonDisabled = true;
      var param = { Memo: adminMemo };
      axios
        .put(self.$store.state.APIbase + "api/adminMemo/" + classNum, param)
        .then(() => {
          self.infoText = "クラスのメモを変更しました";
          self.modalInfo = true;
          setTimeout(function () {
            self.modalInfo = false;
          }, 2000);
          self.buttonDisabled = false;
        })
        .catch(() => {});
    },
    delClasses: function () {
      var self = this;
      if (!self.classNum.length) {
        self.caution = true;
      } else {
        self.modalCaution = true;
        self.modalText =
          "クラスを削除すると生徒データも削除され、元に戻すことができません。<br>本当に削除していいですか？";
      }
    },
    del: function () {
      var self = this;
      if (self.classNum) {
        for (var i = 0; i < self.classNum.length; i++) {
          axios
            .put(
              self.$store.state.APIbase + "api/classDelete/" + self.classNum[i]
            )
            .then((res) => {
              self.delClass.push(res.data);
            });
        }
        self.classNum = [];
        axios.get(self.$store.state.APIbase + "api/classrooms").then((res) => {
          self.classes = res.data;
        });
        self.delInfo = true;
        setTimeout(function () {
          self.delInfo = false;
          self.modalCaution = false;
        }, 3000);
      }
    },
    modalCancel: function (e) {
      if (e == "modal") {
        this.modal = false;
      } else if (e == "dataModal") {
        this.dataModal = false;
      } else if (e == "caution") {
        this.modalCaution = false;
      }
    },
    getLog: function () {
      axios({
        url: this.$store.state.APIbase + "api/log",
        method: "GET",
        responseType: "blob",
      }).then((res) => {
        if (window.navigator.msSaveOrOpenBlob) {
          // for IE,Edge
          window.navigator.msSaveOrOpenBlob(res.data, "log.csv");
        } else {
          // for chrome, firefox
          const url = URL.createObjectURL(
            new Blob([res.data], { type: "text/csv" })
          );
          const linkEl = document.createElement("a");
          linkEl.href = url;
          linkEl.setAttribute("download", "log.csv");
          document.body.appendChild(linkEl);
          linkEl.click();

          URL.revokeObjectURL(url);
          linkEl.parentNode.removeChild(linkEl);
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  min-height: 100vh;
  background: #ffefef;
}
.head {
  width: 100%;
  height: 50px;
  min-height: 30px;
  background: #ffd0d0;
  text-align: center;
}
.row {
  text-align: center;
}
.login {
  padding-top: 70px;
  background: #ffefef;
  box-shadow: 0px -4px 2px rgba(0, 0, 0, 0.5);
  text-align: center;
}
.button {
  padding-top: 10px;
  padding-bottom: 40px;
  transition: all 0.3s;
}
@media (min-width: 700px) {
  .button {
    margin-left: 0;
    margin-right: 3%;
  }
}
.button:hover {
  transform: scale(1.1);
}
.button:active {
  transform: scale(0.9);
}

.info {
  background: #ffd8d8;
  width: 90%;
  margin-left: 5%;
  margin-top: -50px;
  margin-bottom: 20px;
  padding: 5px;
  border-radius: 5px;
}
.modal {
  position: fixed;
  top: 10%;
  width: 90%;
  margin-left: 5%;
  padding: 5px;
  background: #ffefef;
  border: solid 2px #ffd0d0;
  text-align: center;
  transition: all 1.2s;
  height: 80%;
  overflow: auto;
}
.modalInfo {
  position: fixed;
  top: 40%;
  width: 90%;
  background: #fffff1;
  border: #725035;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.submitButton {
  background: #ffd0d0;
}
.modalCaution {
  position: fixed;
  top: 10%;
  width: 90%;
  margin-left: 5%;
  padding: 5px;
  background: #ffefef;
  border: solid 2px #992929;
  text-align: center;
  transition: all 1.2s;
}

table {
  margin-left: auto;
  margin-right: auto;
  font-size: x-small;
}
td,
th {
  padding: 12px 15px !important;
  border: solid 1px #c1c1c1;
}
.totalcolumn th,
.totalcolumn td {
  background: #ffd0d0;
}
.tableButton {
  text-align: center;
  border: solid 1px gray;
  border-radius: 5%;
  text-align: center;
  margin: 0;
  padding: 0 2px;
  font-weight: normal;
}
.caution {
  color: #b10000;
}

.adminMemo {
  background-color: rgba(255, 255, 255, 0);
  min-height: 1rem;
  margin: 0;
  width: 100%;
  border: none;
}
</style>
